export enum LoadingStatusEnum {
  notLoaded = 'notLoaded',
  needsToLoad = 'needsToLoad',
  loading = 'loading',
  error = 'error',
  complete = 'complete',
}
